import { Action, createReducer, on } from '@ngrx/store';
import * as CoreStoreActions from './core-store.actions';
import { initialState, State } from './core-store.state';

const rootReducer = createReducer(
  initialState,

  on(CoreStoreActions.pushAppNotification, (state, { notification }) => ({
    ...state,
    appNotifications: [notification, ...state.appNotifications],
  })),
  on(CoreStoreActions.dismissAppNotification, (state, { id }) => {
    const appNotifications = state.appNotifications.filter(
      notification => notification.id !== id,
    );
    return {
      ...state,
      appNotifications,
    };
  }),
  on(CoreStoreActions.dismissAppNotificationsWithTopic, (state, { topic }) => {
    const appNotifications = state.appNotifications.filter(
      notification => notification.topic !== topic,
    );
    return {
      ...state,
      appNotifications,
    };
  }),
);

export function reducer(state: State | undefined, action: Action) {
  return rootReducer(state, action);
}
